<template>
  <div class="heroesLeaderboard">
    <div class="hero_box">
      <div class="head-title">
        <div class="middle-title">课程: </div>
        <el-select v-model="select_course" placeholder="请选择课程" @change="changeCourse" clearable style="width: 240px;">
          <el-option v-for="item in teacherCourseList" :key="item.course_id" :label="item.course_name" :value="item.course_id"></el-option>
        </el-select>
        <div class="middle-title" v-if="role==3" style="margin-left: 20px;">班级: </div>
        <el-select v-if="role==3" v-model="classValue" placeholder="请选择班级" @change="changeClass" clearable style="width: 240px;">
          <el-option v-for="item in classList" :key="item.c_id" :label="item.c_name" :value="item.c_id"></el-option>
        </el-select>
      </div>
      <el-table :data="tableData.slice((pageParams.page-1)*pageParams.size,pageParams.page*pageParams.size)" style="
                width: 100%;
                flex: 1;
                border: 1px solid #f2f4f7;
                border-radius: 4px;margin-top: 30px;
            " size="medium" :header-cell-style="{
                fontWeight: 'normal',
                color: '#333',
                background: '#f5f7fa',
            }" class="table-content" :cell-style="{ fontSize: '12px', color: '#333' }">
        <el-table-column label="排名" align="center">
          <template slot-scope="scope">
            <div v-if="scope.$index<=2" style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
              <img v-if="scope.$index==0" style="width: 26px;height: 26px;" src="../../assets/img/image/number1.png" alt="">
              <img v-if="scope.$index==1" style="width: 26px;height: 26px;" src="../../assets/img/image/number2.png" alt="">
              <img v-if="scope.$index==2" style="width: 26px;height: 26px;" src="../../assets/img/image/number3.png" alt="">

            </div>
            <span v-else> {{ scope.$index+1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="头像">
          <template slot-scope="scope">
            <div class="img_box">
              <img v-if="!scope.row.s_ico" src="../../assets/images/user_img.png" alt="">
              <img v-else :src="scope.row.s_ico" alt="">
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="s_name" label="姓名">
        </el-table-column>
        <el-table-column prop="s_sex" label="性别">
          <template slot-scope="scope">
            {{ scope.row.s_sex? scope.row.s_sex:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="s_account" label="学号">
        </el-table-column>
        <el-table-column prop="comp_score" label="得分">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination :current-page="pageParams.page" :page-size="pageParams.size" @current-change="handleCurrentChange" background layout="prev, pager, next, total" :total="tableData.length">
        </el-pagination>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      select_course: "",
      classValue: "",
      classList: [],
      teacherCourseList: [],
      tableData: [],
      pageParams: {
        page: 1,
        size: 10,
        paging: 1,
        total: 0,
      },
      total: 0,
      role: localStorage.getItem("role"),
    };
  },
  methods: {
    getTeacherCourseList() {
      return new Promise((resolve, reject) => {
        if (this.role == 3) {
          this.$thttp.axiosGet(this.$api.showTeaCourse, (res) => {
            if (res.code === 200) {
              this.teacherCourseList = res.data.course_list;
              this.select_course = this.teacherCourseList[0].course_id;
              resolve();
            } else {
              this.$message.error(res.msg);
              reject(new Error(res.msg));
            }
          });
        } else {
          let param = {
            type: 1,
            parent_id: "no",
            sort: 1,
          };
          this.$shttp.axiosGetBy(this.$api.admin_courseLists, param, (res) => {
            if (res.code === 200) {
              this.teacherCourseList = res.list;
              this.select_course = this.teacherCourseList[0].course_id;
              resolve();
            } else {
              this.$message.error(res.msg);
              reject(new Error(res.msg));
            }
          });
        }
      });
    },
    getClassList() {
      return new Promise((resolve, reject) => {
        this.$shttp.axiosGet(
          this.$api.showClass,
          (res) => {
            if (res.code === 200) {
              this.classList = res.data;
              this.classValue = this.classList[0].c_id;
              resolve();
            } else {
              this.$message.error(res.msg);
              reject(new Error(res.msg));
            }
          },
          (err) => {
            console.log(err);
            reject(err);
          }
        );
      });
    },
    getTableData() {
      return new Promise((resolve, reject) => {
        let role = localStorage.getItem("role");
        if (role == 3) {
          this.$shttp.axiosPost(
            this.$api.jdCourseRankingGetRanking,
            { course_id: this.select_course, class_id: this.classValue },
            (res) => {
              if (res.code === 200) {
                this.tableData = res.data;

                resolve();
              } else {
                this.$message.error(res.msg);
                reject(new Error(res.msg));
              }
            },
            (err) => {
              console.log(err);
              const errorData = err.response.data;
              this.$message.error(errorData.msg);
              reject(err);
            }
          );
        } else {
          this.$http.axiosPost(
            this.$api.jdCourseRankingGetRanking,
            {
              course_id: this.select_course,
              class_id: Number(localStorage.getItem("c_id")),
            },
            (res) => {
              if (res.code === 200) {
                this.tableData = res.data;
                resolve();
              } else {
                this.$message.error(res.msg);
                reject(new Error(res.msg));
              }
            },
            (err) => {
              const errorData = err.response.data;
              this.$message.error(errorData.msg);
              reject(err);
            }
          );
        }
      });
    },
    async fetchData(role) {
      try {
        if (role == 3) {
          await Promise.all([this.getTeacherCourseList(), this.getClassList()]);
          await this.getTableData();
        } else {
          await this.getTeacherCourseList();
          await this.getTableData();
        }
      } catch (error) {
        console.error("数据获取出错:", error);
      }
    },
    changeCourse() {
      this.getTableData();
    },
    changeClass() {
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.pageParams.page = val;
    },
  },
  mounted() {
    let role = localStorage.getItem("role");
    this.fetchData(role);
  },
};
</script>
<style lang="scss" scoped>
.heroesLeaderboard {
  width: 100%;
  height: 100%;
  background: #fff;
  .hero_box {
    padding: 30px 18.75% 20px 18.75%;
    height: calc(100% - 50px);
    .head-title {
      // margin-left: 40px;
      display: flex;
      align-items: center;
      .middle-title {
        margin-right: 10px;
      }
    }
    .pagination {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      margin-top: 30px;
    }
  }
}
.img_box {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  img {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    object-fit: cover;
  }
}
</style>